export const navigation = [
	{
		"NAME": "Transportauftrag",
		"COMPONENT": "Transportauftrag",
		"CHILDREN": [
			{
				"NAME": "Transportauftrag anzeigen",
				"COMPONENT": "TransportauftragList",
				"CHILDREN": [
					// {
					// 	"NAME": "Transportauftrag bearbeiten",
					// 	"COMPONENT": "TransportauftragEdit",
					// 	"CHILDREN": []
					// }
				]
			},
			{
				"NAME": "Transportauftrag erstellen",
				"COMPONENT": "TransportauftragCreate",
				"CHILDREN": []
			},
            {
                "NAME": "Artikel umbuchen",
                "COMPONENT": "ArtikelUmbuchen",
                "CHILDREN": []
            }
		]
	},
];
